import {
    PergolaShapeId,
    PergolaOptionsId,
} from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { PergolaRoofId } from '@core/constants/Option';
import {
    IFormFieldShape,
    IFormFieldMaterial,
    IFormFieldShapeQuantities,
    IFormFieldDimension,
    IFormInputType,
    IDimensionUnit,
    IFormFieldRadioList,
} from '../../../interfaces/Form';
import {
    getMaterialsWithExceptions,
    allMetals,
    allPlastics,
    allSolidWoods,
} from './materialGroups';

export const fieldsPergolaShape: IFormFieldShape = {
    value   : undefined,
    options : [
        PergolaShapeId.PergolaLeaned,
        PergolaShapeId.PergolaSelfSupporting,
    ],
    required: true,
};

export const fieldsPergolaCLassicMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allSolidWoods,
                ...allMetals,
                ...allPlastics,
            ],
            [
                MaterialId.Poplar,
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Walnut,
                MaterialId.AshOlive,
                MaterialId.Acacia,
                MaterialId.Mahogany,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Teak,
                MaterialId.Wenge,
                MaterialId.Cherrywood,
                MaterialId.Ebony,
                MaterialId.Rubber,
                MaterialId.Steel,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.SheetMetal,
                MaterialId.Zinc,
                MaterialId.PlexiglassFluorescent,
                MaterialId.PlexiglassFrosted,
                MaterialId.PlexiglassMirror,
                MaterialId.PlexiglassTransparent,
                MaterialId.PlexiglassWhite,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
                MaterialId.RecycledPlastic,
            ],
        ),
        required: true,
    },
};

export const fieldsPergolaBioClimaticMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(allMetals,
            [
                MaterialId.Steel,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.Iron,
                MaterialId.SheetMetal,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
                MaterialId.WroughtIron,
            ]),
        required: true,
    },
};

export const fieldPergolaClassicRoof: IFormFieldRadioList = {
    value   : undefined,
    options : [
        PergolaRoofId.ClassicCanvas,
        PergolaRoofId.RollUpCanvas,
        PergolaRoofId.GlassRoof,
        PergolaRoofId.AdjustableBlades,
    ],
    required: true,
};

export const fieldPergolaBioclimaticRoof: IFormFieldRadioList = {
    value   : undefined,
    options : [
        PergolaRoofId.RollUpCanvas,
        PergolaRoofId.AdjustableBlades,
    ],
    required: true,
};

export const fieldsPergolaDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 2000, max: 3500 },
        required     : true,
        defaultValue : 2200,
    },
    [FieldDimensionId.Length]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 1000, max: 4000 },
        required     : true,
        defaultValue : 2000,
    },
    [FieldDimensionId.Width]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 2000, max: 5000 },
        required     : true,
        defaultValue : 3000,
    },
};

export const fieldsPergolaOptions: IFormFieldShapeQuantities = {
    [PergolaOptionsId.PergolaLighting]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [PergolaOptionsId.PergolaHeater]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [PergolaOptionsId.PergolaStore]: {
        value : undefined,
        min   : 0,
        max   : 4,
    },
};
